import React, { useState,useEffect } from 'react';
import { Card, Col, Row, Form, Badge  } from 'react-bootstrap';
// import { useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import axios from 'axios'
import $ from 'jquery'
import Modal from 'react-bootstrap/Modal';
import linkedinIcon from '../assets/images/icons/con_linkedin_icn.svg';
import facebookIcon from '../assets/images/icons/con_facebook_icn.svg';
import twitterIcon from '../assets/images/icons/con_twitter_icn.svg';
import instaIcon from '../assets/images/icons/con_insta_icn.svg';
import previewIcon from '../assets/images/preview_icn.svg';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const StayInTouch = ({children}) => {
    // let navigate = useNavigate();
    const [fullscreen, setFullscreen] = useState(true);
    const [show, setShow] = useState(false);
    const handleShow = (breakpoint) => {
        setFullscreen(breakpoint);
        setShow(true);
      }
      $(document).ready(function(){
        $(".react-tel-input .form-control").addClass("mobile_class");
        $(".mobile_class").attr("id","mobile");
        $(".mobile_class").attr("name","mobile");
        $(".mobile_class").attr("required",'true');
    });
      const [ip, setIP] = useState('');
    //console.log("ip",ip);
    var values;
    const [phoneNumber, setphoneNumber]=useState()
    // const [stayTouchDetail, setstayTouchDetail] = useState({
    //     Name: "",
    //     Email: "",
    //     Mobile_Number: "",
    //     Message: "",
    //     Details:"",
    //   });
    //   const { Name, Email, Message } = stayTouchDetail;
    //   const onInputChange = (e) => {
    //     setstayTouchDetail({ ...stayTouchDetail, [e.target.name]: e.target.value })
    //   }
    //   const onphonechange=()=>{
    //     values = $('.react-tel-input .form-control ').val();
      //  console.log("demo",values)
        // setphoneNumber(values);
        // setstayTouchDetail({ ...stayTouchDetail, 
        //     Details: {ip},
        //     Mobile_Number: phoneNumber,
        //  });
        
    //   }
    //  console.log("phone_number",phoneNumber)
    //   const onSubmit = async (e) => {
        // setstayTouchDetail({ ...stayTouchDetail, MobileNumber: phoneNumber })
        // e.preventDefault();
        
      //  console.log("contact us", stayTouchDetail);
        // await axios.post(process.env.REACT_APP_BASE_URL+`postStayInTouch`, stayTouchDetail);
        // navigate("../", { replace: true });
        // setShow(false);
    //   };
    //   const getData = async () => {
    //     const res = await axios.get('https://geolocation-db.com/json/')
       // console.log(res.data);
        // setIP(res.data.IPv4)
    //   }
      
    
      useEffect(()=>{
        //console.log("contact_details", stayTouchDetail);
        // getData();
      },[]);
  return (
    <span className='stay_touch_modal'>
        <Button className="me-2 mb-2" onClick={() => handleShow(true)}>
        {children}
        </Button>
      <Modal className='stay_touch_container' show={show} fullscreen={fullscreen} onHide={() => setShow(false)}>
        <Modal.Header className='stay_touch_header' closeButton>
        </Modal.Header>
        <Modal.Body className='d-flex align-items-center'>
            
            <Col xl={6} md={8} xs={11} className='mx-auto'>
            <h5 className='stay_common_title'>Stay in touch</h5>
            <div className='stay_sub_title mb-4'>We’ll get through this together</div>
            <Card className='form_container'>
            <Form className='p-4 m-3' 
                action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8" 
                method="POST">
                <input type="hidden" name="oid" value="00D30000000nHvC" />
                <input type="hidden" name="retURL" value="https://www.bicsglobal.com/" />
                <Row>
                <Col xl={12} md={12} xs={12}>
                    <Row>
                    <Form.Group className="mb-3 col-12 col-md-6">
                        <Form.Label className='stay_touch_title'>FIRST NAME</Form.Label>
                        <Form.Control 
                            className='stay_touch_input px-0 pt-3' 
                            type="text"
                            // value={Name}
                            id="first_name"
                            name="first_name"
                            placeholder="Enter Your Name" 
                            // onChange={(e) => onInputChange(e)}
                            required
                            />
                    </Form.Group>
                    <Form.Group className="mb-3 col-12 col-md-6">
                        <Form.Label className='stay_touch_title'>LAST NAME</Form.Label>
                        <Form.Control 
                            className='stay_touch_input px-0 pt-3' 
                            type="text"
                            // value={Name}
                            name="last_name"
                            id="last_name"
                            placeholder="Enter Your Name" 
                            required
                            // onChange={(e) => onInputChange(e)}
                            />
                    </Form.Group>
                    </Row>
                    <Row>
                    <Form.Group className="mb-3 col-12 col-md-6">
                        <Form.Label className='stay_touch_title'>EMAIL</Form.Label>
                        <Form.Control 
                            className='stay_touch_input px-0 pt-3'
                            type="email" 
                            name="email"
                            id="email"
                            // value={Email}
                            placeholder="Enter Your Email" 
                            required
                            // onChange={(e) => onInputChange(e)}
                            />
                    </Form.Group>
                    
                    <Form.Group className="mb-3 col-12 col-md-6">
                        <Form.Label className='stay_touch_title'>MOBILE NUMBER</Form.Label>
                        <PhoneInput
                                        country={'in'}
                                        name="mobile"
                                        id="mobile"
                                        className="stay_mob_number"
                                        // onChange={() => onphonechange()}
                                    />
                    </Form.Group>
                    </Row>
                    <Form.Group className="mb-3 col-12">
                        <Form.Label className='stay_touch_title'>YOUR MESSAGE</Form.Label>
                            
                                 <Form.Control 
                                    className='stay_touch_input px-0 pt-3' 
                                    as="textarea" 
                                    name="00N30000008c2Ir"
                                    id="00N30000008c2Ir"
                                    // value={Message}
                                    aria-label="With textarea"
                                    required
                                    // onChange={(e) => onInputChange(e)}
                                    placeholder=" Enter your brief message . . ."/>
                    </Form.Group>
                    <Row>
                    <div className='d-flex col-12 col-md-6 social_block mb-3'>
                    <h6 className='mt-1 stay_social_title'>CONNECT THROUGH</h6>
                    <div className=''>
                        <a href="https://in.linkedin.com/company/bicsglobal" target="_blank">
                    <img src={linkedinIcon} alt="socialicon" className='stay_touch_social_icon' />
                    </a>
                    <a href="https://twitter.com/bicsglobal" target="_blank">
                    <img src={twitterIcon} alt="socialicon" className='stay_touch_social_icon' />
                    </a>
                    <a href="https://www.facebook.com/bicsglobal" target="_blank">
                        <img src={facebookIcon} alt="socialicon" className='stay_touch_social_icon' />
                    </a>
                        <a href="https://www.instagram.com/bicsglobal/" target="_blank">
                    <img src={instaIcon} alt="socialicon" className='stay_touch_social_icon'/>
                    </a>
                    </div>
                    </div>
                    <div className='text-right col-12 col-md-6'>
                        <Button variant="success" type="submit" className='stay_submit px-5 py-2'
                        // onClick={(e) => onSubmit(e)}
                        >
                            Submit
                        </Button>
                    </div>
                    </Row>
                </Col>
                {/* <Col xl={5} md={12} xs={12} className="demo">
                    <h5 className="stay_right_title pb-4">ARTICLES FOR YOU</h5>
                    <div className="stay_right_section">
                        <form>
                            <div className="form-group">
                                <input type="checkbox" id="Article1" />
                                <label for="Article1" className='d-flex'>
                                    <div className='stay_check_content'>
                                        <h5>Related Article 01 <Badge bg="primary" className='mx-3'><img src={previewIcon} className="previewicn_align" width={8} alt="preview icon"/>Preview</Badge></h5>
                                        <div className='article_text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean luctus lorem vel leo maximus bibendum. Mauris vitae ante lorem.</div>
                                    </div>
                                </label>
                            </div>
                            <div className="form-group">
                                <input type="checkbox" id="Article2" />
                                <label for="Article2" className='d-flex'>
                                    <div className='stay_check_content'>
                                        <h5>Related Article 02 <Badge bg="primary" className='mx-3'><img src={previewIcon} className="previewicn_align" width={8} alt="preview icon"/>Preview</Badge></h5>
                                        <div className='article_text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean luctus lorem vel leo maximus bibendum. Mauris vitae ante lorem.</div>
                                    </div>
                                </label>
                            </div>
                            <div className="form-group">
                                <input type="checkbox" id="Article3" />
                                <label for="Article3" className='d-flex'>
                                    <div className='stay_check_content'>
                                        <h5>Related Article 03 <Badge bg="primary" className='mx-3'><img src={previewIcon} className="previewicn_align" width={8} alt="preview icon"/>Preview</Badge></h5>
                                        <div>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean luctus lorem vel leo maximus bibendum. Mauris vitae ante lorem.</div>
                                    </div>
                                </label>
                            </div>
                        </form>
                    </div>
                    <div className='text-right'>
                        <Button variant="success" type="submit" className='stay_submit px-5 py-2'
                        onClick={(e) => onSubmit(e)}>
                            Submit
                        </Button>
                    </div>
                </Col> */}
                </Row>
                </Form>
            </Card>
            </Col>
        </Modal.Body>
      </Modal>
    </span>
  )
}

export default StayInTouch
